import React, { useContext } from 'react';

// components
import { Loading } from '@design-system-coopeuch/web';
import { StyledLoader } from '../../../assets/styles/styles';

// context
import LoaderContext from './LoaderContext';

const Loader = () => {
  const { loading } = useContext(LoaderContext);
  return (
    loading && (
      <StyledLoader className="">
        <Loading />
      </StyledLoader>
    )
  );
};

export default Loader;
